// ErrorBoundary.styles.ts
//
// O cartão que aparece NO LUGAR da tela branca. Mesmos tokens do resto da
// Configuração (--sp-*, --fs-*, tema) — não é desenho novo, é o mesmo "Aviso"
// tom erro que employeesSection e advancedSection já usam, com espaço para o
// nome da sub-tela e a mensagem literal do erro.
import styled from "styled-components";

export const Caixa = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-12);
  margin: var(--sp-16) var(--sp-20) var(--sp-24);
  padding: var(--sp-16);
  border-radius: 8px;
  border: 1px solid #f0b7b2;
  background: #fdf0ef;
  color: #8c2b23;
  font-size: var(--fs-sm);
  line-height: 1.55;
`;

export const Titulo = styled.h2`
  display: flex;
  align-items: center;
  gap: var(--sp-10);
  margin: 0;
  font-size: var(--fs-lg);
  font-weight: 600;
  color: #8c2b23;
`;

export const Icone = styled.span`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: var(--fs-xl);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Mensagem = styled.pre`
  margin: 0;
  padding: var(--sp-12);
  border-radius: 6px;
  border: 1px solid #f0b7b2;
  background: #ffffff;
  font-size: var(--fs-xs);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;
`;

export default { Caixa, Titulo, Icone, Mensagem };
